import { BaseEntity } from 'yt-ng-framework';

export class StrucnoUsavrsavanje extends BaseEntity {
    constructor(){
        super();
    }
    
    
    OsobaId: number = null;
    TipPotvrdeOStrucnomUsavrsavanjuId: number = null;
    TipStrucnogUsavrsavanjaId: number = null;
    Naziv: string = null;
    Predavac: string = null;
    Trajanje: number = null;
    Datum: Date = null;
    RealizovanOdDatuma: Date = null;
    RealizovanDoDatuma: Date = null;
    BrojBodova: number = null;
    Institucija: string = null;
    KataloskiBroj: string = null;
    Mesto: string = null;
    USvojstvuPredavaca: boolean = false;
    Obavezno: boolean = false;
    
    Deserialize(input: any){
        this.ID = input.ID;
        this.OsobaId = input.OsobaID;
        this.TipPotvrdeOStrucnomUsavrsavanjuId = input.TipPotvrdeOStrucnomUsavrsavanjuID;
        this.TipStrucnogUsavrsavanjaId = input.TipStrucnogUsavrsavanjaID;
        this.Naziv = input.Naziv;
        this.Predavac = input.Predavac;
        this.Trajanje = input.Trajanje;
        this.Datum = input.Datum;
        this.RealizovanOdDatuma = input.RealizovanOdDatuma;
        this.RealizovanDoDatuma = input.RealizovanDoDatuma;
        this.BrojBodova = input.BrojBodova;
        this.Institucija = input.Institucija;
        this.KataloskiBroj = input.KataloskiBroj;
        this.Mesto = input.Mesto;
        this.USvojstvuPredavaca = input.USvojstvuPredavaca;
        this.Obavezno = input.Obavezno;

        return this;
    }

    Serialize(input: StrucnoUsavrsavanje){
        return input;
    }
}
